import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	description: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.description',
		defaultMessage:
			'Set an issue security level to control who can view issues created with this request type. <link>Read more about issue security</link>',
		description: 'Description for the request type issue security configuration modal.',
	},
	descriptionIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.description-issue-term-refresh',
		defaultMessage:
			'Set a work item security level to control who can view work items created with this request type. <link>Read more about work item security</link>',
		description: 'Description for the request type issue security configuration modal.',
	},
	manageSecurityLevelsLink: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.manage-security-levels-link',
		defaultMessage: 'Manage security levels',
		description: 'Text for link to manage security levels.',
	},
	goToIssueSecurityLink: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.go-to-issue-security-link',
		defaultMessage: 'Go to issue security',
		description: 'Text for link to go to issue security.',
	},
	goToIssueSecurityLinkIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.go-to-issue-security-link-issue-term-refresh',
		defaultMessage: 'Go to work item security',
		description: 'Text for link to go to issue security.',
	},
	missingLevelError: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.missing-level-error',
		defaultMessage: 'Security level is no longer available',
		description: 'Error message when the selected security level is no longer available.',
	},
	requiredError: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.required-error',
		defaultMessage: 'Select a security level',
		description: 'Error message when a security level is required.',
	},
	placeholder: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.placeholder',
		defaultMessage: 'Select level',
		description: 'Placeholder for the request type issue security configuration dropdown.',
	},
	selectLabel: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.select-label',
		defaultMessage: 'Security level',
		description: 'Label for the request type issue security configuration dropdown.',
	},
	memberOfSecurityLevel: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.member-of-security-level',
		defaultMessage: 'Member',
		description:
			'Label for the group in the dropdown showing the security levels the user is assigned to',
	},
	notMemberOfSecurityLevel: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.not-member-of-security-level',
		defaultMessage: 'Not a member',
		description:
			'Label for the group in the dropdown showing the security levels the user is not assigned to',
	},
	alwaysUseProjectDefaultSecurityLevel: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.always-use-project-default-security-level',
		defaultMessage: 'Always use default security level',
		description: 'Label for the radio button to use the default security level',
	},
	selectSecurityLevel: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.select-security-level',
		defaultMessage: 'Use security level other than default',
		description: 'Label for the radio button to explicitly select the security level',
	},
	noDefaultSecurityLevelPopup: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.no-default-security-level-popup',
		defaultMessage:
			'This project is using an issue security scheme that doesn’t have a default set.',
		description: 'Label displayed to tell the user there is no security level',
	},
	noDefaultSecurityLevelPopupIssueTermRefresh: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.no-default-security-level-popup-issue-term-refresh',
		defaultMessage:
			'This project is using a work item security scheme that doesn’t have a default set.',
		description: 'Label displayed to tell the user there is no security level',
	},
	isRequiredPopup: {
		id: 'servicedesk-request-type-security.config-button.config-modal.issue-security-config.is-required-popup',
		defaultMessage:
			'When the security level field is required, this option isn’t available as a level must be manually selected.',
		description:
			'Message that displays in the popup when the user cannot use the project default security level.',
	},
});
